import { Component, Input } from '@angular/core';
import { LayerId } from '../../../../types';
import { RecorderStore } from '../../../stores/recorder.store';

@Component({
  selector: 'app-timeline-layer-remove',
  templateUrl: './timeline-layer-remove.component.html',
  styleUrls: ['./timeline-layer-remove.component.styl']
})
export class TimelineLayerRemoveComponent {
  @Input() layerId: LayerId;

  constructor(
    private recorderStore: RecorderStore,
  ) {
  }

  onClick() {
    this.recorderStore.removeLayer(this.layerId);
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer-remove/timeline-layer-remove.component.ts